import {NgModule} from '@angular/core';
import {DataLettersPipe} from './data-letters.pipe';
import {EnumFilterByPropPipe} from './enum-filter-by-prop.pipe';
import {PhonePipe} from './phone.pipe';
import {SearchPipe} from './search.pipe';
import {HighlightSearchPipe} from './highlight-search.pipe';
import {MessageHtmlPipe} from './message-html.pipe';


@NgModule({
  declarations: [
    DataLettersPipe,
    EnumFilterByPropPipe,
    PhonePipe,
    SearchPipe,
    HighlightSearchPipe,
    MessageHtmlPipe
  ],
  exports: [
    DataLettersPipe,
    EnumFilterByPropPipe,
    PhonePipe,
    SearchPipe,
    HighlightSearchPipe,
    MessageHtmlPipe
  ]
})
export class EePipesModule {}
